import React from "react";
import { motion } from "framer-motion";
import { GraduationCap, Award } from "lucide-react";
import { Section, SectionHeading } from "./_shared";

const Education = ({ items = [], certifications = [] }) => (
  <Section id="education">
    <SectionHeading
      index="05"
      label="Education & Credentials"
      title="Foundations."
      testId="education-heading"
    />
    <div className="grid lg:grid-cols-2 gap-6">
      {items.map((e, i) => (
        <motion.div
          key={e.id || i}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: i * 0.06 }}
          className="glass glass-hover rounded-3xl p-7 md:p-8"
          data-testid={`education-${i}`}
        >
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-cyan-400/20 to-violet-500/20 border border-white/10 grid place-items-center">
              <GraduationCap size={18} className="text-cyan-300" />
            </div>
            <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-cyan-300">{e.period}</span>
          </div>
          <h3 className="font-display text-2xl md:text-3xl tracking-tight text-white font-medium">{e.school}</h3>
          <div className="mt-1 text-slate-300">{e.degree}</div>
          <div className="mt-2 flex items-center gap-3 text-sm">
            <span className="text-slate-500">{e.location}</span>
            <span className="text-cyan-300 font-mono">{e.gpa}</span>
          </div>
          {e.notes && <p className="mt-4 text-sm text-slate-400 leading-relaxed">{e.notes}</p>}
        </motion.div>
      ))}
      {certifications.length > 0 && (
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.08 }}
          className="glass glass-hover rounded-3xl p-7 md:p-8"
          data-testid="certifications-card"
        >
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-cyan-400/20 to-violet-500/20 border border-white/10 grid place-items-center">
              <Award size={18} className="text-cyan-300" />
            </div>
            <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-cyan-300">Certifications</span>
          </div>
          <ul className="space-y-3">
            {certifications.map((c) => (
              <li key={c.id} className="flex items-start justify-between gap-3 border-b border-white/5 pb-3 last:border-0">
                <div>
                  <div className="text-white text-sm font-medium">{c.name}</div>
                  <div className="text-slate-500 text-xs mt-0.5">{c.issuer}</div>
                </div>
                <span className="font-mono text-[11px] text-cyan-300">{c.year}</span>
              </li>
            ))}
          </ul>
        </motion.div>
      )}
    </div>
  </Section>
);

export default Education;
